import { StringField, LinkField, DropdownSelect, FooterLink, FooterLinkFields } from "../../types/types";
import mock from "../../mocks/Footer/FooterLink.mock"

export class FooterLinkModel {
  private readonly fields?: FooterLinkFields;
  public displayField?:string;
  constructor(props: FooterLink) {
    this.fields = props.fields;
    this.displayField = props.displayName;
  }

  get displayName() : string {
    return this?.displayField ?? '';
  } 

  get link(): LinkField {
    return this.fields?.Link ?? mock.fields.Link
  }

  get linkUrl(): string {
    return this.link?.value?.href || '';
  }

  get hasLink(): boolean {
    return !(!this.linkUrl || (this.linkUrl === 'http://' && this.linkText));
  }

  get linkText(): string {
    return this.link?.value?.text || '';
  }

  get list(): FooterLink[] {
    return this.fields?.List ?? mock.fields.List 
  }

  get title(): StringField {
    return this.fields?.Title ?? mock.fields.Title;
  }

  get type(): DropdownSelect {
    return this.fields?.Type ?? mock.fields.Type;
  }
}
